export default "## Nutzungsbedingungen\n\n[Fügen Sie hier Ihre individuellen Nutzungsbedingungen ein...]"